<button
  #trigger
  type="button"
  class="form-control dp-trigger"
  [class.dp-trigger--open]="open()"
  [class.dp-trigger--placeholder]="!value()"
  [class.dp-trigger--filled]="!!value()"
  [disabled]="disabled()"
  aria-haspopup="dialog"
  [attr.aria-expanded]="open()"
  (click)="toggle()"
  (keydown)="onTriggerKeydown($event)"
>
  <i class="fe fe-calendar dp-icon" aria-hidden="true"></i>
  <span class="dp-value">{{ displayValue() || placeholder }}</span>
</button>
<!-- Apagar a data sem ter de abrir o calendário para encontrar o "Limpar" lá dentro: é o que se
     tenta primeiro, e o campo é um botão, por isso o teclado sozinho não o fazia. -->
@if (value() && !disabled()) {
  <button
    type="button"
    class="dp-clear"
    aria-label="Limpar data"
    title="Limpar data"
    (click)="clear()"
  ><i class="fe fe-x" aria-hidden="true"></i></button>
}

<div
  #popup
  class="dp-popup"
  popover="manual"
  role="dialog"
  aria-label="Selecionar data"
  [style.top.px]="position().top"
  [style.left.px]="position().left"
>
  <div class="dp-header">
    <button
      type="button"
      class="dp-nav"
      [disabled]="!canGoBack()"
      (click)="prevMonth()"
      aria-label="Mês anterior"
    >
      <i class="fe fe-chevron-left" aria-hidden="true"></i>
    </button>
    <span class="dp-month">{{ monthLabel() }}</span>
    <button
      type="button"
      class="dp-nav"
      [disabled]="!canGoForward()"
      (click)="nextMonth()"
      aria-label="Próximo mês"
    >
      <i class="fe fe-chevron-right" aria-hidden="true"></i>
    </button>
  </div>

  <div class="dp-weekdays">
    @for (w of weekdays; track $index) {
      <span class="dp-weekday">{{ w }}</span>
    }
  </div>

  <div class="dp-days">
    @for (d of days(); track d.iso) {
      <button
        type="button"
        class="dp-day"
        [class.dp-day--outside]="!d.current"
        [class.dp-day--today]="d.today"
        [class.dp-day--selected]="d.selected"
        [disabled]="d.disabled"
        (click)="select(d)"
      >{{ d.day }}</button>
    }
  </div>

  <div class="dp-footer">
    <button type="button" class="dp-quick" [disabled]="!todayAllowed()" (click)="selectToday()">Hoje</button>
    <button type="button" class="dp-quick" (click)="clear()">Limpar</button>
  </div>
</div>
